module.exports = __webpack_public_path__ + "img/hardwareRouter2.42ddaee9.png";